/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*INICIO SCRIPT TABELA DE PARCELAMENTO MODELO 2*/
document.addEventListener( 'DOMContentLoaded', function () {
  
      // Update price if variant changed
  
      function _updateProductPriceForBillet( currentVariant ) {
  
          if ( !currentVariant ) {
              return;
          }
  
          const billet = document.querySelector( '.parcelament' );
          const money = formatMoney( currentVariant.price, window.theme.moneyFormat );
  
          if ( billet ) {
              billet.textContent = formatMoney( currentVariant.price * 1, window.theme.moneyFormat );
          }
  
      }
  
  
  function formatMoney( cents, format ) {
          if ( typeof cents === 'string' ) {
              cents = cents.replace( ',', '' );
          }
  
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
              formatString = format || '${{amount}}';
  
          function defaultTo( value, defaultValue ) {
              return value == null || value !== value ? defaultValue : value;
          }
  
          function formatWithDelimiters( number, precision, thousands, decimal ) {
              precision = defaultTo( precision, 2 );
              thousands = defaultTo( thousands, '.' );
              decimal = defaultTo( decimal, ',' );
  
              if ( isNaN( number ) || number == null ) {
                  return 0;
              }
  
              number = ( number / 100.0 ).toFixed( precision );
              var parts = number.split( '.' ),
                  dollarsAmount = parts[ 0 ].replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands ),
                  centsAmount = parts[ 1 ] ? decimal + parts[ 1 ] : '';
              return dollarsAmount + centsAmount;
          }
  
          var value = '';
  
          switch ( formatString.match( placeholderRegex )[ 1 ] ) {
              case 'amount':
                  value = formatWithDelimiters( cents, 2 );
                  break;
  
              case 'amount_no_decimals':
                  value = formatWithDelimiters( cents, 0 );
                  break;
  
              case 'amount_with_space_separator':
                  value = formatWithDelimiters( cents, 2, ' ', '.' );
                  break;
  
              case 'amount_no_decimals_with_comma_separator':
                  value = formatWithDelimiters( cents, 0, ',', '.' );
                  break;
  
              case 'amount_no_decimals_with_space_separator':
                  value = formatWithDelimiters( cents, 0, ' ' );
                  break;
  
              case 'amount_with_comma_separator':
                  value = formatWithDelimiters( cents, 2, '.', ',' );
                  break;
          }
  
          // 	if ( formatString.indexOf( 'with_comma_separator' ) !== -1 ) {
          // 		return formatString.replace( placeholderRegex, value ).replace( ',00', '' );
          // 	} else {
          // 		return formatString.replace( placeholderRegex, value ).replace( '.00', '' );
          // 	}
          return formatString.replace( placeholderRegex, value );
      }
  
  
      function getCurrentVariant() {
  
          const productJsonElement = document.querySelector( '[data-product-json]' ); // If we are using placeholder, there is no JSON so we wrap here!
  
          if ( productJsonElement ) {
              const jsonData = JSON.parse( productJsonElement.innerHTML );
              const productData = jsonData[ 'product' ];
  
              productData[ 'variants' ].forEach( function ( variant ) {
                  if ( variant[ 'id' ] === jsonData[ 'selected_variant_id' ] ) {
                      currentVariant = variant;
                  }
              } );
          }
  
          return currentVariant;
      }  
    
  
  function _updatePartialPrices ( variant ) {

        if ( !variant ) {
            return;
        }
    
    const preco = variant.price - (variant.price * 0);

      var parcelas = [
    { vezes: 1, times: 1.0000 },
    { vezes: 2, times: 1.0000 },
    { vezes: 3, times: 1.0000 },
    { vezes: 4, times: 1.1087 },
    { vezes: 5, times: 1.1232 }, 
    { vezes: 6, times: 1.1370 },
    { vezes: 7, times: 1.472 },
    { vezes: 8, times: 1.1627 },
    { vezes: 9, times: 1.1774 },
    { vezes: 10, times: 1.1872 },
    { vezes: 11, times: 1.2021 },
    { vezes: 12, times: 1.2167 },
  ]
    
    function calculo (preco, times, vezes) {
      return ((preco + 0) * times / vezes );
    }
    
    var el_vezes = Array.from($('.vezes'))
    
    parcelas.forEach(function (parcela, position) {
      var calculo_vezes = calculo(preco, parcela.times, parcela.vezes)
      
      calculo_vezes = formatMoney(calculo_vezes, window.theme.moneyFormat);
      calculo_vezes = ( calculo_vezes);
    
      $(el_vezes[parcela.vezes - 1]).html('<span>' + calculo_vezes +  '</span>');
    })
  }
  
  
      function init() {
  
          const currentVariant = getCurrentVariant();
          const billetPrice = document.querySelector( '.parcelament' );

  
          if ( billetPrice ) {
              billetPrice.textContent = formatMoney( currentVariant.price * 1, window.theme.moneyFormat )
          }
  
  
          document.addEventListener( 'variant:changed', function ( event ) {
              const variant = event.detail.variant; // Gives you access to the whole variant details
              _updateProductPriceForBillet( variant );
              _updatePartialPrices( variant );
          } );
      }
  
      init();
    
    
  });
  /*FINAL SCRIPT TABELA DE PARCELAMENTO MODELO 2*/

var k=(new Date).getTime(),b=setInterval(function(){if(3845<(new Date).getTime()-k)clearInterval(b);else{var e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,98,101,116,97,46,97,108,105,104,117,110,116,101,114,46,105,111,39,93));for(e.length<1&&(e=document.querySelectorAll(String.fromCodePoint(97,91,104,114,101,102,61,39,104,116,116,112,115,58,47,47,97,108,105,104,117,110,116,101,114,46,105,111,39,93)));0<e.length;)e[0].style.display=String.fromCodePoint(110,111,110,101)}},769);document.addEventListener(String.fromCodePoint(68,79,77,67,111,110,116,101,110,116,76,111,97,100,101,100),function(){-1<document.location.href.indexOf(String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108,63,115,111,114,116,95,98,121,61,98,101,115,116,45,115,101,108,108,105,110,103))&&(document.location.href=String.fromCodePoint(47,99,111,108,108,101,99,116,105,111,110,115,47,97,108,108))},!1);

if (window.matchMedia("(max-width: 768px)").matches) {
  	window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
	}
} 

function parcelamento() {
  var preco = $('.product-form__info-item .price--highlight').text().split('                  ')[0].replace('R$ ','').replace(',', '.').trim()
  var compare = $('.product-form__info-item .price--compare').text().replace('R$ ', '').replace(',','.')
  var compare = parseFloat(compare)
  var precompare = (compare - preco).toFixed(2).replace('.', ',')
  $('.product-label.product-label--on-sale span').text('R$ '+ precompare)
  var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0]
  $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%')    
  var preco = parseFloat(preco);
  var calculo = ((preco + 0) * 1.1979) / 12;
  var calculo = calculo.toFixed(2).replace('.', ',');
  var calculo = ('R$ ' + calculo);
  $('.parcelamento').html('<span>em até 12x de <b>' + calculo + '</b></span>');
}


$(".block-swatch__radio").change(function () {
  setTimeout(function () { parcelamento(); }, 150);
});